import {
  Checkbox,
  Dialog,
  Divider,
  FormControlLabel,
  Skeleton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "../../analytics/analytics.css";
import "./savedPaymentModal.css";
import HoverToDisplayFullTitle from "../../../reusableComponents/HoverToDisplayFullTitle";
import CustomButton from "../../../reusableComponents/CustomButton";
import "../../analytics/analytics.css";
import IOSSwitch from "../../checkout/IOSSwitch";
import { useAuth } from "../../../context/API_Client";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import SmallModal from "../../../reusableComponents/modals/SmallModal";
import { colorBrandObject } from "../../../../constants/brandings";
import { readableColor } from "polished";

const SavedPaymentMethodModal = ({
  toggleDialog,
  data,
  updateToggleDialog,
  operationPermissions
}) => {

  const { updatePaymentMethod, isAuthorizedPermission } = useAuth();
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const paymentMethodCategoryDict = data?.pspPaymentCategoryDict;
  const [activatedCategories, setActivatedCategories] = useState(data?.paymentMethodIds);
  const [checkboxStatus, setCheckboxStatus] = useState({});
  const [showWarning, setShowWarning] = useState({});
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [activePatmentCategoryAndId, setActivePatmentCategoryAndId] = useState({});

  useEffect(() => {
    setActivatedCategories(data?.paymentMethodIds);
    let selectAllStatus = {};
    if (data?.pspPaymentCategoryDict) {
      for (const category of data?.pspPaymentCategoryDict) {
        let idx = data?.activatedPaymentCategoryDict.findIndex(
          (activeCategory) => activeCategory?.name === category?.name
        );
        if (idx < 0) {
          selectAllStatus[`${category?.name}`] = false;
        } else {
          selectAllStatus[`${category?.name}`] =
            data?.activatedPaymentCategoryDict[idx].value.length ===
            category.value.length;
        }
      }
      setCheckboxStatus(selectAllStatus);
    }
    if (data?.activatedPaymentCategoryDict) {
      let actPatmentCategoryAndId = {};
      for (const category of data?.activatedPaymentCategoryDict) {
        actPatmentCategoryAndId[`${category?.name}`] = [];

        for (const val of category?.value) {
          actPatmentCategoryAndId[`${category?.name}`].push(val?.id);
        }
      }
      setActivePatmentCategoryAndId(actPatmentCategoryAndId);
    }
  }, [data]);

  useEffect(() => {
    if (paymentMethodCategoryDict) {
      setSelectedCategory(paymentMethodCategoryDict[0]);
    }
    return () => {
      setSelectedTab(0);
      setSelectedCategory(null);
    };
  }, [data]);

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      updateToggleDialog(false, null);
    }
  };

  const updateCategories = (id) => {
    let selectedCategoryName = selectedCategory?.name;
    let actIds = activePatmentCategoryAndId[selectedCategoryName] || [];
    let pspPaymentCategoryDictData = data?.pspPaymentCategoryDict?.find(
      (cat) => cat?.name == selectedCategoryName
    );
    if (actIds?.includes(id)) {
      actIds = actIds?.filter((catId) => catId !== id);
    } else {
      actIds.push(id);
    }
    actIds?.length === pspPaymentCategoryDictData?.value?.length
      ? setCheckboxStatus((prev) => ({ ...prev, [selectedCategoryName]: true }))
      : setCheckboxStatus((prev) => ({
        ...prev,
        [selectedCategoryName]: false,
      }));
    setActivePatmentCategoryAndId((prev) => ({
      ...prev,
      [selectedCategoryName]: actIds,
    }));
    activatedCategories?.includes(id)
      ? setActivatedCategories((prev) => prev?.filter((val) => val !== id))
      : setActivatedCategories((prev) => [...prev, id]);
  };

  useEffect(() => {
    if (selectedCategory?.name in activePatmentCategoryAndId) {
      let showWarning = false;
      activePatmentCategoryAndId[`${selectedCategory?.name}`]?.length === 0
        ? (showWarning = true)
        : (showWarning = false);
      setShowWarning((prev) => ({
        ...prev,
        [selectedCategory?.name]: showWarning,
      }));
    }
  }, [activePatmentCategoryAndId]);

  const handleSelcectAll = () => {
    if (checkboxStatus[`${selectedCategory?.name}`]) {
      let valuesToBeFilters = [];
      for (const value of selectedCategory?.value) {
        if (activatedCategories?.includes(value?.id)) {
          valuesToBeFilters.push(value?.id);
        }
      }
      let remainingCategories = [];
      activatedCategories.forEach((value) =>
        valuesToBeFilters.includes(value)
          ? null
          : remainingCategories.push(value)
      );
      setActivePatmentCategoryAndId((prev) => ({
        ...prev,
        [selectedCategory?.name]: [],
      }));
      setActivatedCategories([...remainingCategories]);
      setCheckboxStatus((prev) => ({
        ...prev,
        [selectedCategory?.name]: false,
      }));
      setShowWarning((prev) => ({
        ...prev,
        [selectedCategory?.name]: true,
      }));
    } else {
      let remainingCategories = [];
      let allIds = [];
      for (const value of selectedCategory?.value) {
        if (!activatedCategories?.includes(value?.id)) {
          remainingCategories.push(value.id);
        }
        allIds.push(value?.id);
      }
      setActivePatmentCategoryAndId((prev) => ({
        ...prev,
        [selectedCategory?.name]: allIds,
      }));
      setActivatedCategories((prev) => [...prev, ...remainingCategories]);
      setCheckboxStatus((prev) => ({
        ...prev,
        [selectedCategory?.name]: true,
      }));
      setShowWarning((prev) => ({
        ...prev,
        [selectedCategory?.name]: false,
      }));
    }
  };

  const updatePspConfig = () => {
    let payload = data?.originalConfig;
    let ruleIdx = payload?.rules?.findIndex(
      (rule) => rule?.countryCode === data?.countryCode
    );
    payload.rules[ruleIdx].paymentMethodIds = activatedCategories;
    updatePaymentMethod(
      data?.originalConfig?.pspCode,
      data?.legalEntityCode,
      payload,
      function (data) {
        customToast("success", "high", `PSP Configuration Updated`);
        setOpenConfirmationModal(false);
        updateToggleDialog(false, null, true);
        localStorage.removeItem("allModalData");
        localStorage.removeItem("paymentMethods");
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };

  return (
    <Dialog
      open={toggleDialog}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
          borderRadius: "12px",
          width: "860px",
          // height: "570px",
        },
      }}
      onKeyDown={handleKeyDown}
    >
      <div className="saved-payment-modal-root">
        <div className="saved-payment-modal-header-content">
          <div className="saved-payment-modal-title">
            <Typography className="SemiboldTwenty">
              Edit Payment Methods
            </Typography>
            <div className="processor-container"
              style={{
                border: ` 1px solid ${colorBrandObject.primaryButtonColor}`,
                background: `${colorBrandObject.mainKpiColor}`,

              }}
            >
              <Typography className="bodyB2RegularText" style={{ color: "white" }}>
                {data?.pspName}
              </Typography>
            </div>
          </div>
          <CloseIcon
            sx={{ width: "24px", height: "24px" }}
            className="icon"
            onClick={() => updateToggleDialog(false, null)}
          />
        </div>
        <Divider />
        {paymentMethodCategoryDict?.length >= 0 && (
          <div className="container-tabs">
            {paymentMethodCategoryDict?.map((tab, i) => {
              return (
                <div
                  className={selectedTab === i ? "active-tab" : "inActive-tab"}
                  onClick={() => {
                    setSelectedTab(i);
                    setSelectedCategory(tab);
                  }}
                >
                  <Typography
                    className={
                      selectedTab === i
                        ? "active-tab-font"
                        : "inActive-tab-font"
                    }
                  >
                    {tab?.name}
                  </Typography>
                </div>
              );
            })}
          </div>
        )}

        <div className="saved-payment-modal-content">
          <div className="catgery-save-all">
            <Typography className="semiboldSixteen">
              {selectedCategory?.name}
            </Typography>
            <FormControlLabel
              sx={{
                marginBottom: "0px",
              }}
              control={
                <Checkbox
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: "500",
                    fontSize: "14px",
                    height: "18px",
                    color: "rgba(36, 183, 170, 1)",
                    marginRight: "8px",
                  }}

                  onClick={(event) => handleSelcectAll(event.target.checked)}
                  checked={
                    selectedCategory?.name in checkboxStatus &&
                    checkboxStatus[`${selectedCategory?.name}`]
                  }
                  indeterminate={
                    selectedCategory?.name in activePatmentCategoryAndId &&
                    selectedCategory?.name in checkboxStatus &&
                    activePatmentCategoryAndId[`${selectedCategory?.name}`]
                      ?.length > 0 &&
                    !checkboxStatus[`${selectedCategory?.name}`]
                  }
                  sx={{
                    '& .MuiSvgIcon-root': {
                      color: colorBrandObject?.secondaryButtonColor,
                    },
                    '&.Mui-checked': {
                      color: colorBrandObject?.secondaryButtonColor,
                      '& .MuiSvgIcon-root': {
                        fill: colorBrandObject?.secondaryButtonColor,
                      },
                    },
                  }}
                />
              }
              label="Select All"
            />
          </div>

          {showWarning[`${selectedCategory?.name}`] && (
            <div
              className="saved-payment-warning-container"
              style={{ display: "flex", alignItems: "center" }}
            >
              <img
                src="/assets/info-circle.svg"
                alt="info"
                style={{ marginTop: "2px" }}
              />
              <p
                class="unselectall-warning-msg"
                style={{ margin: 0, marginLeft: "8px" }}
              >
                Please note removing all the payment categories from the gateway
                configuration will remove it from the checkout as well.
              </p>
            </div>
          )}

          <div className="scroll-container">
            <div className="category-items-container">
              {!selectedCategory
                ? [...Array(8)].map(() => {
                  return (
                    <div className="category-item">
                      <Skeleton
                        variant="rounded"
                        width={"100%"}
                        height={"45px"}
                        sx={{
                          borderRadius: "10px",
                        }}
                      />
                    </div>
                  );
                })
                : selectedCategory?.value
                  ?.map((item) => ({
                    ...item,
                    title: item?.title?.trimStart(),
                  }))
                  ?.sort((a, b) =>
                    a.title.localeCompare(b.title, undefined, {
                      sensitivity: "base",
                    })
                  )
                  .map((item) => {
                    return (
                      <div className="category-item" key={item?.id}>
                        <div
                          className="psp-img-title"
                          style={{ position: "r elative" }}
                        >
                          <img
                            src={item?.logoUrl}
                            alt={"processor"}
                            width={"24px"}
                            height={"24px"}
                          />

                          <div className="category-font">
                            <HoverToDisplayFullTitle
                              title={item?.title}
                              len={20}
                            />
                          </div>
                        </div>

                        <FormControlLabel
                          hidden={!isAuthorizedPermission(operationPermissions.updatePG) && !isAuthorizedPermission(operationPermissions.createPG)}
                          control={
                            <IOSSwitch
                              key={item.id}
                              onClick={() => {
                                updateCategories(item?.id);
                              }}
                              checked={activatedCategories?.includes(
                                item?.id
                              )}
                              sx={{
                                "& .MuiSwitch-switchBase.Mui-checked": {
                                  color: "white"
                                },
                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                  backgroundColor: colorBrandObject?.secondaryButtonColor,
                                },
                              }}
                            />
                          }
                        />
                      </div>
                    );
                  })}
            </div>
          </div>
        </div>
        <div className="saved-payment-bottom">
          <CustomButton
            text={"Cancel"}
            variant={"outlined"}
            type={"secondary"}
            size={"sm"}
            onClick={() => updateToggleDialog(false)}
          />
          {
            isAuthorizedPermission(operationPermissions.updatePG) && isAuthorizedPermission(operationPermissions.createPG) && (
              <CustomButton
                text={"Save"}
                variant={"contained"}
                type={"secondary"}
                size={"sm"}
                onClick={() => setOpenConfirmationModal(true)}
              />
            )
          }
        </div>
      </div>
      <SmallModal
        type={"secondary"}
        toggleDialog={openConfirmationModal}
        headerText={"Info"}
        subHeaderText={
          "Please note once you update the payment methods, it affects your online payments collection. Please verify before making any changes."
        }
        outlinedBtnText={"Cancel"}
        outlinedBtnFunction={() => setOpenConfirmationModal(false)}
        filledBtnText={"Confirm"}
        filledBtnFunction={() => updatePspConfig()}
      />
    </Dialog>
  );
};

export default SavedPaymentMethodModal;
